import {
  Button,
  Modal,
  Radio,
  Checkbox,
  Select,
  Tooltip,
  Layout,
  Typography,
} from "antd";
import React, { useMemo, useState } from "react";
import BrandsLogicalGroup from "../../layout/WelcomePage/Template/BrandsLogicalGroup";
import Datetime from "../../layout/DateTime";
import { useDispatch, useSelector } from "react-redux";
import {
  callNotification,
  getPaneIndex,
  getTemplateListBasicObject,
  removePrivateConversationFilters,
} from "../../../redux/constants";
import {
  setEditTemplate,
  setSaveTemplate,
} from "../../../redux/actions/ApiCall/apiCall";
import { useParams } from "react-router-dom";
import { setTemplateDetails } from "../../../redux/actions/section/section";
import { setAllSelectedCheckbox } from "../../../redux/actions/widget/widget";
import { useEffect } from "react";
import Text from "antd/lib/typography/Text";
import Paragraph from "antd/lib/typography/Paragraph";
import { setDashboardFilters } from "../../../redux/actions/dashboard/Tab1";
import infoIcon from "../../../assets/information-button.svg";
import { benchmarkAggregation } from "../../../redux/constants/enums";

const SaveDashboardModal = ({
  isDashboardModalOpen,
  setIsDashboardModalOpen,
  setIsDashboardSave,
  isDashboard,
  setIsSaveTemplate,
}) => {
  const dispatch = useDispatch();

  const { id } = useParams();
  const { Option } = Select;
  const [dashboardType, setDashboardType] = useState("custom");

  const [quickFilter, setQuickFilter] = useState("");
  const [channelList, setChannelList] = useState("");
  const [socialChannel, setSocialChannel] = useState(false);
  const [lock, setLock] = useState({
    is_brand_locked: false,
    is_date_locked: false,
  });
  const [templateType, setTemplateType] = useState("custom");
  const [aggrigation, setAggrigation] = useState("avg");
  const footerValue = useSelector((state) => state.Section.footerValue);
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const Section = useSelector((state) => state.Section.addSection);
  const sectionDetails = useSelector((state) => state.Section.sectionDetails);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const isEditTemplate = useSelector((state) => state.Section.isEditTemplate);
  const global_dashboard_duration = useSelector(
    (state) => state.AuthParams.global_dashboard_duration
  );
  const global_dashboard_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_brands
  );
  const global_dashboard_single_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_single_brands
  );
  const templateSectionFetchLoader = useSelector(
    (state) => state.ApiCall.templateSectionFetchLoader
  ); //display chart loader
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  let index = getPaneIndex(panes, activeKey);

  const competitorBrands = useSelector(
    (state) => state.WidgetAPI.competitorBrands?.data?.result
  );

  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const Allbrands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const workspace_privileges = useSelector(
    (state) => state.ApiCall.workspace_privileges
  );

  const getWindowSize = () => {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  };

  const getPageSize = (windowSize) => {
    let currentWindowSize = windowSize?.innerWidth;

    if (currentWindowSize >= 2261) {
      return 21;
    } else if (currentWindowSize < 2261 && currentWindowSize >= 1905) {
      return 18;
    } else if (currentWindowSize < 1905 && currentWindowSize >= 1590) {
      return 15;
    } else if (currentWindowSize < 1590 && currentWindowSize >= 1278) {
      return 12;
    } else if (currentWindowSize < 1278 && currentWindowSize >= 966) {
      return 12;
    } else if (currentWindowSize < 966) {
      return 10;
    }
    return 12;
  };

  const [windowSize, setWindowSize] = useState(getWindowSize());
  const [pageSize, setPageSize] = useState(getPageSize(windowSize));

  useEffect(() => {
    if (isEditTemplate) {
      let index = getPaneIndex(panes, activeKey);
      setDashboardType(
        templateDetails?.template_type === "competition"
          ? "competition"
          : templateDetails?.template_type === "benchmarking"
          ? "benchmarking"
          : "custom"
      );
      setTemplateType(
        templateDetails?.template_type === "competition"
          ? "competition"
          : templateDetails?.template_type === "benchmarking"
          ? "benchmarking"
          : "custom"
      );
      setAggrigation(
        panes[index]?.competition_aggregation
          ? panes[index]?.competition_aggregation
          : "avg"
      );
      setQuickFilter(
        templateDetails?.template_type === "competition"
          ? ""
          : panes[index]?.quick_filter
          ? panes[index]?.quick_filter
          : ""
      );
      setChannelList(
        panes[index]?.hidden_filter
          ? panes[index]?.hidden_filter?.columns[0]?.name
          : ""
      );
      panes[index]?.hidden_filter &&
        panes[index]?.hidden_filter?.columns[0]?.name &&
        setSocialChannel(true);
      setLock({
        ...lock,
        is_brand_locked: templateDetails?.is_brand_locked
          ? templateDetails?.is_brand_locked
          : false,
        is_date_locked: templateDetails?.is_date_locked
          ? templateDetails?.is_date_locked
          : false,
      });
    } else if (
      ["competition", "benchmarking"]?.includes(templateDetails?.template_type)
    ) {
      setDashboardType(
        templateDetails?.template_type
          ? templateDetails?.template_type
          : "custom"
      );
      setTemplateType(
        templateDetails?.template_type
          ? templateDetails?.template_type
          : "custom"
      );
      setAggrigation(
        panes[index]?.competition_aggregation
          ? panes[index]?.competition_aggregation
          : "avg"
      );
      if (templateDetails?.template_type === "competition") setQuickFilter("");
    }
  }, [isEditTemplate]);

  const handleOk = () => {
    setIsDashboardModalOpen(false);
  };
  const handleCancel = () => {
    setIsDashboardModalOpen(false);
    setIsDashboardSave(false);
    dispatch(
      setTemplateDetails(templateDetails, {
        // advance_brands: [],
        quick_filter: null,
      })
    );
  };
  // const onDashboardTypeChange = (e) => {
  //   if (e?.target?.value === "custom") {
  //     setTemplateType("custom");
  //     setAggrigation("avg");
  //     setDashboardType("custom");
  //     if (
  //       (templateDetails?.advance_brands?.columns &&
  //         templateDetails?.advance_brands?.columns[0]?.competitor) ||
  //       (Array.isArray(templateDetails?.advance_brands) &&
  //         templateDetails?.advance_brands[0]?.competitor)
  //     ) {
  //       dispatch(
  //         setTemplateDetails(templateDetails, {
  //           template_type: "custom",
  //           advance_brands: [],
  //         })
  //       );
  //       if (lock?.is_brand_locked && lock?.is_date_locked) {
  //         setLock({
  //           is_brand_locked: false,
  //           is_date_locked: true,
  //         });
  //       } else if (lock?.is_brand_locked && !lock?.is_date_locked) {
  //         setLock({
  //           is_brand_locked: false,
  //           is_date_locked: false,
  //         });
  //       }
  //     } else {
  //       dispatch(
  //         setTemplateDetails(templateDetails, {
  //           template_type: "custom",
  //         })
  //       );
  //     }

  //     setDashboardType("custom");
  //   } else if (e?.target?.value === "competition") {
  //     setTemplateType("competition");
  //     setQuickFilter("");
  //     setDashboardType("competition");
  //     if (channelList === "LinkedIn") {
  //       setChannelList("");
  //       setSocialChannel(false);
  //     }
  //     if (
  //       (templateDetails?.advance_brands?.columns &&
  //         !templateDetails?.advance_brands?.columns[0]?.competitor) ||
  //       (Array.isArray(templateDetails?.advance_brands) &&
  //         !templateDetails?.advance_brands[0]?.competitor)
  //     ) {
  //       dispatch(
  //         setTemplateDetails(templateDetails, {
  //           template_type: "competition",
  //           advance_brands: [],
  //         })
  //       );
  //       if (lock?.is_brand_locked && lock?.is_date_locked) {
  //         setLock({
  //           is_brand_locked: false,
  //           is_date_locked: true,
  //         });
  //       } else if (lock?.is_brand_locked && !lock?.is_date_locked) {
  //         setLock({
  //           is_brand_locked: false,
  //           is_date_locked: false,
  //         });
  //       }
  //     } else {
  //       dispatch(
  //         setTemplateDetails(templateDetails, {
  //           template_type: "competition",
  //         })
  //       );
  //     }
  //   } else if (e?.target?.value === "benchmarking") {
  //     setTemplateType("benchmarking");
  //     setAggrigation("avg");
  //     setDashboardType("benchmarking");
  //     if (
  //       (templateDetails?.advance_brands?.columns &&
  //         !templateDetails?.advance_brands?.columns[0]?.competitor) ||
  //       (Array.isArray(templateDetails?.advance_brands) &&
  //         !templateDetails?.advance_brands[0]?.competitor)
  //     ) {
  //       dispatch(
  //         setTemplateDetails(templateDetails, {
  //           template_type: "benchmarking",
  //           advance_brands: [],
  //         })
  //       );
  //       if (lock?.is_brand_locked && lock?.is_date_locked) {
  //         setLock({
  //           is_brand_locked: false,
  //           is_date_locked: true,
  //         });
  //       } else if (lock?.is_brand_locked && !lock?.is_date_locked) {
  //         setLock({
  //           is_brand_locked: false,
  //           is_date_locked: false,
  //         });
  //       }
  //     } else {
  //       dispatch(
  //         setTemplateDetails(templateDetails, {
  //           template_type: "benchmarking",
  //         })
  //       );
  //     }
  //   }
  // };

  // Refactored code
  const onDashboardTypeChange = (e) => {
    const selectedType = e?.target?.value;
    const isCustom = selectedType === "custom";
    const isCompetition = selectedType === "competition";
    const isBenchmarking = selectedType === "benchmarking";

    const isCompetitorBrandPresent =
      (templateDetails?.advance_brands?.columns &&
        templateDetails?.advance_brands?.columns[0]?.competitor) ||
      (Array.isArray(templateDetails?.advance_brands) &&
        templateDetails?.advance_brands[0]?.competitor);

    const resetLockIfBrandLocked = () => {
      if (lock?.is_brand_locked && lock?.is_date_locked) {
        setLock({ is_brand_locked: false, is_date_locked: true });
      } else if (lock?.is_brand_locked) {
        setLock({ is_brand_locked: false, is_date_locked: false });
      }
    };

    const updateTemplateDetails = (type, resetAdvanceBrands) => {
      const newDetails = {
        template_type: type,
        ...(resetAdvanceBrands && { advance_brands: [] }),
      };
      dispatch(setTemplateDetails(templateDetails, newDetails));
    };
    if (isCustom || isBenchmarking) {
      setTemplateType(selectedType);
      setAggrigation("avg");
      setDashboardType(selectedType);
    }

    if (isCompetition) {
      setTemplateType("competition");
      setDashboardType("competition");
      setQuickFilter("");

      if (channelList === "LinkedIn") {
        setChannelList("");
        setSocialChannel(false);
      }
    }

    const needsReset =
      isCustom || isBenchmarking
        ? isCompetitorBrandPresent
        : !isCompetitorBrandPresent;

    updateTemplateDetails(selectedType, needsReset);

    if (needsReset) {
      resetLockIfBrandLocked();
    }
  };
  const onQuickFilterChange = (e) => {
    dispatch({ type: "SET_DASHBOARD_QUICK_FILTER", payload: e.target.value });
    setQuickFilter(e.target.value);
    dispatch(
      setTemplateDetails(templateDetails, {
        quick_filter: e.target.value,
        advance_brands: [],
      })
    );
  };
  const onChannelChange = (e) => {
    setChannelList(e.target.value);
    if (
      quickFilter &&
      !graphConditionConfig?.[`quick_filter_channel_mapping`]?.[
        quickFilter
      ]?.includes(e.target.value)
    ) {
      let updatedQuickFilter = null;
      let mappingOfChanelWiseQuickFilter =
        graphConditionConfig?.[`quick_filter_channel_mapping`];
      let keysOfChanelWiseQuickFilter = mappingOfChanelWiseQuickFilter
        ? Object?.keys(mappingOfChanelWiseQuickFilter)
        : [];
      for (let i = 0; i < keysOfChanelWiseQuickFilter?.length; i++) {
        let key = keysOfChanelWiseQuickFilter?.[i];
        if (
          key &&
          mappingOfChanelWiseQuickFilter?.[key] &&
          Array.isArray(mappingOfChanelWiseQuickFilter?.[key]) &&
          mappingOfChanelWiseQuickFilter?.[key]?.includes(e.target.value)
        ) {
          if (
            graphConditionConfig?.[`quick_filter_mapping`] &&
            Array.isArray(graphConditionConfig?.[`quick_filter_mapping`])
          ) {
            let qObj = graphConditionConfig?.[`quick_filter_mapping`]?.find(
              (q) => q?.text === key
            );
            updatedQuickFilter = qObj ? qObj?.value : null;
          }
          break;
        }
      }
      dispatch({
        type: "SET_DASHBOARD_QUICK_FILTER",
        payload: updatedQuickFilter,
      });
      setQuickFilter(updatedQuickFilter);
      dispatch(
        setTemplateDetails(templateDetails, {
          quick_filter: updatedQuickFilter,
          advance_brands: [],
        })
      );
    }
  };
  const onCheckBoxChange = (e) => {
    if (e.target.checked) {
      setSocialChannel(e.target.checked);
      setChannelList("Facebook");
    } else {
      setSocialChannel(e.target.checked);
      if (quickFilter === "AccountID" || quickFilter === "ObjectID") {
        dispatch({
          type: "SET_DASHBOARD_QUICK_FILTER",
          payload: null,
        });
        setQuickFilter(null);
        dispatch(
          setTemplateDetails(templateDetails, {
            quick_filter: null,
            // advance_brands: [],
          })
        );
      }
      setChannelList("");
    }
  };
  const onBenchMarkChange = (e) => {
    setAggrigation(e);
  };
  const onLockSelectedBrandChange = (e) => {
    setLock({ ...lock, [`is_brand_locked`]: e.target.checked });
  };
  const onLockSelectedDurationChange = (e) => {
    setLock({ ...lock, [`is_date_locked`]: e.target.checked });
  };

  const handleSaveDashboard = () => {
    let pathName = window.location.pathname?.split("/")?.[1];
    if (
      // footerValue?.template &&
      (pathName === "edit-dashboard" || pathName === "create-dashboard") &&
      Section[0]?.id &&
      templateDetails?.templateName &&
      templateDetails?.templateName?.trim().length !== 0 &&
      Section[0]?.data?.length !== 0
    ) {
      let index = getPaneIndex(panes, activeKey);
      let filtersData = templateDetails?.templateFilters
        ? templateDetails?.templateFilters
        : [];

      if (panes?.[index]?.quick_filter || panes?.[index]?.hidden_filter) {
        // let quickFilter =
        //   panes?.[index]?.quick_filter === "Category"
        //     ? "CategoryID"
        //     : panes?.[index]?.quick_filter === "AccountID"
        //     ? "SettingID"
        //     : panes?.[index]?.quick_filter;
        // let hiddenFilter = panes?.[index]?.hidden_filter?.attribute;

        // filtersData = filtersData
        //   ? quickFilter
        //     ? filtersData?.filter((el) => el?.attribute !== quickFilter)
        //     : filtersData
        //   : [];

        // filtersData = filtersData?.length
        //   ? hiddenFilter
        //     ? filtersData?.filter((el) => el?.attribute !== hiddenFilter)
        //     : filtersData
        //   : [];
        if (
          templateDetails?.template_type === "competition" ||
          (panes?.[index]?.template_type === "competition" &&
            ["custom", "benchmarking"]?.includes(
              templateDetails?.template_type
            ))
        ) {
          filtersData = removePrivateConversationFilters(
            graphConditionConfig?.comp_hidden_filter,
            filtersData
          );
        }
        filtersData = filtersData ? filtersData : [];
        dispatch(setDashboardFilters(filtersData, index, panes));
      } else {
        if (
          templateDetails?.template_type === "competition" ||
          (panes?.[index]?.template_type === "competition" &&
            ["custom", "benchmarking"]?.includes(
              templateDetails?.template_type
            ))
        ) {
          filtersData = removePrivateConversationFilters(
            graphConditionConfig?.comp_hidden_filter,
            filtersData
          );
        }
        filtersData = filtersData ? filtersData : [];
        dispatch(setDashboardFilters(filtersData, index, panes));
      }

      let sectionObject = Section?.map((el) => {
        if (el?.data) {
          let single_brands = [];
          let brandsGroupName = [];
          if (el?.brands) {
            el?.brands?.length > 0 &&
              el?.brandFilters?.columns?.map((el1) => {
                if (el1?.group) {
                  brandsGroupName.push({
                    brand_group_name: el1?.brand_group_name,
                  });
                }
              });
            el?.brands?.length > 0 &&
              el?.brandFilters?.columns?.map((el1) => {
                if (!el1?.group) {
                  single_brands.push({
                    brand_id: el1?.brand_id ? el1?.brand_id : el1?.name,
                    brand_name: el1?.brand_name
                      ? el?.brand_name
                      : el1?.brand_friendly_name,
                  });
                }
              });
          }
          let sectionWidgetObject = [];
          el?.data &&
            el?.data?.map((e) => {
              if (!(e?.childId && e?.duplicate_for_brands)) {
                let single_brands1 = [];
                let brandsGroupName1 = [];
                if (e?.brands) {
                  e?.brands?.length > 0 &&
                    e?.brandFilters?.columns?.map((el1) => {
                      if (el1?.group) {
                        brandsGroupName1.push({
                          brand_group_name: el1?.brand_group_name,
                        });
                      }
                    });
                  e?.brands?.length > 0 &&
                    e?.brandFilters?.columns?.map((el1) => {
                      if (!el1?.group) {
                        single_brands1.push({
                          brand_id: el1?.brand_id ? el1?.brand_id : el1?.name,
                          brand_name: el1?.brand_name
                            ? el1?.brand_name
                            : el1?.brand_friendly_name,
                        });
                      }
                    });
                }
                if (e?.x_axis || e?.y_series || e?.chart) {
                  sectionWidgetObject.push({
                    filters: e?.filters
                      ? e?.filters?.filter(
                          (el) =>
                            el?.attribute !== "BrandID" &&
                            el?.attribute !== "CreatedDate"
                        )
                      : undefined,
                    id: e?.id ? e?.id : null,
                    type: e?.type ? e?.type : "widget-maker",
                    text:
                      e?.type === "rich-content" ||
                      e?.chart?.chart_type === "text"
                        ? e?.text
                        : undefined,
                    widget_name:
                      e?.duplicate_for_brands && e?.parentId
                        ? e?.originalWidgetName
                        : e?.widget_name
                        ? e?.widget_name
                        : null,
                    widget_description: e?.widget_description
                      ? e?.widget_description
                      : null,
                    x_axis: e?.x_axis,
                    y_axes: e?.y_axes?.length > 0 ? e?.y_axes : null,
                    y_series: e?.y_series,
                    filter_dropdown:
                      e?.filter_dropdown?.length > 0 ? e?.filter_dropdown : [],
                    brand_list: e?.brands
                      ? single_brands1?.length > 0
                        ? single_brands1
                        : []
                      : [],
                    brand_groups: e?.brands
                      ? brandsGroupName1?.length > 0
                        ? brandsGroupName1
                        : []
                      : [],
                    chart: e?.chart,
                    order_by: e?.order_by,
                    relative_duration: e?.relative_duration || null,
                    start_date: e?.duration?.from
                      ? e?.duration?.from
                      : e?.start_date,
                    end_date: e?.duration?.to ? e?.duration?.to : e?.end_date,
                    is_locked: e?.is_locked ? e?.is_locked : false,
                    span: e?.span ? e?.span : "full",
                    original_widget_id: isEditTemplate
                      ? e?.original_widget_id
                        ? e?.original_widget_id
                        : e?.widget_id
                      : e?.widget_id,
                    is_imported: true,
                    log: e?.log,
                    data_source: e?.data_source,
                    widget_id: e?.widget_id,
                    engine: e?.engine,
                    supported_filters: e?.supported_filters,
                    profile_filters: e?.profile_filters,
                    widget_uuid: e?.widget_uuid,
                    widget_description_on_icon: e?.widget_description_on_icon,
                    note: e?.note || null,
                    multilevel_breakdown: e?.multilevel_breakdown || null,
                  });
                } else {
                  sectionWidgetObject.push({
                    filters: e?.filters
                      ? e?.filters?.filter(
                          (el) =>
                            el?.attribute !== "BrandID" &&
                            el?.attribute !== "CreatedDate"
                        )
                      : undefined,
                    graph_type: e?.graph_type ? e?.graph_type : "",
                    id: e?.id ? e?.id : null,
                    is_custom: e?.is_custom ? e?.is_custom : false,
                    primary: e?.primary && e?.primary,
                    secondary: e?.secondary ? e?.secondary : null,
                    splits: e?.splits ? e?.splits : null,
                    widget_name:
                      e?.duplicate_for_brands && e?.parentId
                        ? e?.originalWidgetName
                        : e?.widget_name
                        ? e?.widget_name
                        : null,
                    base: e?.base ? e?.base : "mentions",
                    type: e?.type ? e?.type : "graph",
                    text:
                      e?.type === "rich-content" ||
                      e?.chart?.chart_type === "text"
                        ? e?.text
                        : undefined,
                    relative_duration: e?.relative_duration || null,
                    start_date: e?.duration?.from
                      ? e?.duration?.from
                      : e?.start_date,
                    end_date: e?.duration?.to ? e?.duration?.to : e?.end_date,
                    is_locked: e?.is_locked ? e?.is_locked : false,
                    span: e?.span ? e?.span : "full",
                    differential: e?.differential,
                    original_widget_id:
                      e?.type === "predefined" && isEditTemplate
                        ? e?.original_widget_id
                          ? e?.original_widget_id
                          : e?.widget_id
                        : e?.widget_id,
                    is_imported: e?.type === "predefined" ? true : false,
                    source_template: e?.source_template
                      ? e?.source_template
                      : e?.template_id,
                    stacked: e?.stacked,
                    percent: e?.percent,
                    brand_list: e?.brands
                      ? single_brands1?.length > 0
                        ? single_brands1
                        : []
                      : [],
                    brand_groups: e?.brands
                      ? brandsGroupName1?.length > 0
                        ? brandsGroupName1
                        : []
                      : [],
                    log: e?.log,
                    data_source: e?.data_source,
                    widget_id: e?.widget_id,
                    engine: e?.engine,
                    supported_filters: e?.supported_filters,
                    profile_filters: e?.profile_filters,
                    widget_uuid: e?.widget_uuid,
                    widget_description: e?.widget_description,
                    note: e?.note || null,
                  });
                }
                if (e?.duplicate_for_brands && e?.parentId) {
                  e["widget_name"] = e?.originalWidgetName;
                  delete e?.duplicate_for_brands;
                  delete e?.parentId;
                  delete e?.childId;
                  delete e?.span;
                  delete e?.originalWidgetName;
                  delete e?.com_brand_ids;
                }
              }
            });
          return {
            brand_list: el?.brands
              ? single_brands?.length > 0
                ? single_brands
                : []
              : [],
            brand_groups: el?.brands
              ? brandsGroupName?.length > 0
                ? brandsGroupName
                : []
              : [],
            section_name: el?.name ? el?.name : "",
            section_description: el?.description ? el?.description : "",
            relative_duration: el?.relative_duration || null,
            start_date: el?.duration?.from,
            end_date: el?.duration?.to,
            filters: el?.filters ? el?.filters : undefined,
            is_locked: el?.is_locked ? el?.is_locked : false,
            widgets: sectionWidgetObject,
            comp_brand_type:
              templateDetails?.template_type === "competition" &&
              (el?.comp_brand_type === false || el?.comp_brand_type === true)
                ? el?.comp_brand_type
                : undefined,
          };
        }
      });

      let widgetObject = [];

      Section?.map((el) => {
        return el?.data?.map((e) => {
          if (!(e?.childId && e?.duplicate_for_brands)) {
            let single_brands1 = [];
            let brandsGroupName1 = [];
            if (e?.brands) {
              e?.brands?.length > 0 &&
                e?.brandFilters?.columns?.map((el1) => {
                  if (el1?.group) {
                    brandsGroupName1.push({
                      brand_group_name: el1?.brand_group_name,
                    });
                  }
                });
              e?.brands?.length > 0 &&
                e?.brandFilters?.columns?.map((el1) => {
                  if (!el1?.group) {
                    single_brands1.push({
                      brand_id: el1?.brand_id ? el1?.brand_id : el1?.name,
                      brand_name: el1?.brand_name
                        ? el1?.brand_name
                        : el1?.brand_friendly_name,
                    });
                  }
                });
            }
            if (e?.x_axis || e?.y_series || e?.chart) {
              widgetObject.push({
                filters: e?.filters
                  ? e?.filters?.filter(
                      (el) =>
                        el?.attribute !== "BrandID" &&
                        el?.attribute !== "CreatedDate"
                    )
                  : undefined,
                id: e?.id ? e?.id : null,
                type: e?.type ? e?.type : "widget-maker",
                text:
                  e?.type === "rich-content" || e?.chart?.chart_type === "text"
                    ? e?.text
                    : undefined,
                widget_name:
                  e?.duplicate_for_brands && e?.parentId
                    ? e?.originalWidgetName
                    : e?.widget_name
                    ? e?.widget_name
                    : null,
                widget_description: e?.widget_description
                  ? e?.widget_description
                  : null,
                x_axis: e?.x_axis,
                y_axes: e?.y_axes?.length > 0 ? e?.y_axes : null,
                y_series: e?.y_series,
                filter_dropdown:
                  e?.filter_dropdown?.length > 0 ? e?.filter_dropdown : [],
                brand_list: e?.brands
                  ? single_brands1?.length > 0
                    ? single_brands1
                    : []
                  : [],
                brand_groups: e?.brands
                  ? brandsGroupName1?.length > 0
                    ? brandsGroupName1
                    : []
                  : [],
                chart: e?.chart,
                order_by: e?.order_by,
                relative_duration: e?.relative_duration || null,
                start_date: e?.duration?.from
                  ? e?.duration?.from
                  : e?.start_date,
                end_date: e?.duration?.to ? e?.duration?.to : e?.end_date,
                is_locked: e?.is_locked ? e?.is_locked : false,
                span: e?.span ? e?.span : "full",
                original_widget_id: isEditTemplate
                  ? e?.original_widget_id
                    ? e?.original_widget_id
                    : e?.widget_id
                  : e?.widget_id,
                is_imported: true,
                log: e?.log,
                data_source: e?.data_source,
                widget_id: e?.widget_id,
                engine: e?.engine,
                supported_filters: e?.supported_filters,
                profile_filters: e?.profile_filters,
                widget_uuid: e?.widget_uuid,
                widget_description_on_icon: e?.widget_description_on_icon,
                note: e?.note || null,
                multilevel_breakdown: e?.multilevel_breakdown || null,
              });
            } else {
              widgetObject.push({
                filters: e?.filters
                  ? e?.filters?.filter(
                      (el) =>
                        el?.attribute !== "BrandID" &&
                        el?.attribute !== "CreatedDate"
                    )
                  : undefined,
                graph_type: e?.graph_type ? e?.graph_type : "",
                id: e?.id ? e?.id : null,
                is_custom: e?.is_custom ? e?.is_custom : false,
                primary: e?.primary && e?.primary,
                secondary: e?.secondary ? e?.secondary : null,
                splits: e?.splits ? e?.splits : null,
                widget_name:
                  e?.duplicate_for_brands && e?.parentId
                    ? e?.originalWidgetName
                    : e?.widget_name
                    ? e?.widget_name
                    : null,
                base: e?.base ? e?.base : "mentions",
                type: e?.type ? e?.type : "graph",
                text:
                  e?.type === "rich-content" || e?.chart?.chart_type === "text"
                    ? e?.text
                    : undefined,
                relative_duration: e?.relative_duration || null,
                start_date: e?.duration?.from
                  ? e?.duration?.from
                  : e?.start_date,
                end_date: e?.duration?.to ? e?.duration?.to : e?.end_date,
                is_locked: e?.is_locked ? e?.is_locked : false,
                span: e?.span ? e?.span : "full",
                differential: e?.differential,
                original_widget_id:
                  e?.type === "predefined" && isEditTemplate
                    ? e?.original_widget_id
                      ? e?.original_widget_id
                      : e?.widget_id
                    : e?.widget_id,
                is_imported: e?.type === "predefined" ? true : false,
                source_template: e?.source_template
                  ? e?.source_template
                  : e?.template_id,
                stacked: e?.stacked,
                percent: e?.percent,
                brand_list: e?.brands
                  ? single_brands1?.length > 0
                    ? single_brands1
                    : []
                  : [],
                brand_groups: e?.brands
                  ? brandsGroupName1?.length > 0
                    ? brandsGroupName1
                    : []
                  : [],
                log: e?.log,
                data_source: e?.data_source,
                widget_id: e?.widget_id,
                engine: e?.engine,
                supported_filters: e?.supported_filters,
                profile_filters: e?.profile_filters,
                widget_uuid: e?.widget_uuid,
                widget_description_on_icon: e?.widget_description_on_icon,
                widget_description: e?.widget_description,
                note: e?.note || null,
              });
            }
            if (e?.duplicate_for_brands && e?.parentId) {
              e["widget_name"] = e?.originalWidgetName;
              delete e?.duplicate_for_brands;
              delete e?.parentId;
              delete e?.childId;
              delete e?.span;
              delete e?.originalWidgetName;
              delete e?.com_brand_ids;
            }
          }
        });
      });
      let templateData = {
        templateFilters: filtersData,
        template_name: templateDetails?.templateName
          ? templateDetails?.templateName.trim()
          : "",
        template_description: templateDetails?.templateDescription
          ? templateDetails?.templateDescription.trim()
          : "",
        contains_section:
          Section[0]?.onlyWidgets || !Section[0]?.isSectionAdded
            ? false
            : sectionDetails?.isSectionAdded
            ? true
            : false,
        template_type: templateDetails?.template_type
          ? templateDetails?.template_type
          : "custom",
        hidden_filter:
          channelList !== ""
            ? {
                attribute: "SocialMediaPlatforms",
                type: "varchar",
                columns: [
                  {
                    name: channelList,
                    type: "include",
                  },
                ],
              }
            : null,
        quick_filter: quickFilter,
        is_date_locked: templateDetails?.advance_duration?.from
          ? lock?.is_date_locked
          : false,
        is_brand_locked:
          templateDetails?.advance_brands?.columns?.length > 0 ||
          templateDetails?.advance_brands?.length
            ? lock?.is_brand_locked
            : false,
        template_duration: templateDetails?.advance_duration?.from
          ? templateDetails?.advance_duration
          : null,
        competition_aggregation: templateType !== "custom" ? aggrigation : null,
        templateType: templateType,
      };

      let paneObj = {
        template_update: true,
        panes: panes,
        activeKey: activeKey,
        index: index,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        singleBrands: Allbrands,
        templateDetails: { ...templateDetails, ...templateData },
        competitorBrands: competitorBrands,
        global_dashboard_duration: templateDetails?.advance_duration?.from
          ? templateDetails?.advance_duration
          : global_dashboard_duration,
        global_dashboard_brands:
          panes[index].template_type === "ticket"
            ? global_dashboard_single_brands
            : global_dashboard_brands,
        graphConditionConfig: graphConditionConfig,
        type: window.location.pathname === "/schedule" ? "report" : "dashboard",
        save_as: false,
        is_recommended: panes?.[index]?.predefined,
        original_template_id: null,
      };

      let isWidgets = Section?.find((el) => el?.isWidgetAdded === false);

      let paneObject = {
        duration: templateDetails?.templateDuration,
        panes: panes,
        activeKey: activeKey,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        authParams: authParams,
        singleBrands: Allbrands,
        index: index,
        competitorBrands: competitorBrands,
      };
      let paneObject1 = {
        selectBrands: templateDetails?.templateBrands?.columns,
        panes: panes,
        activeKey: activeKey,
        brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
        authParams: authParams,
        index: index,
        singleBrands: brands,
        competitorBrands: competitorBrands,
        templateDetails: templateDetails,
      };

      if (!isWidgets && isEditTemplate && !sectionObject?.includes(undefined)) {
        let basicObj = getTemplateListBasicObject(
          authParams,
          panes,
          index,
          pageSize,
          graphConditionConfig
        );
        dispatch(
          setEditTemplate(
            basicObj,
            id,
            templateData,
            !Section[0]?.onlyWidgets ? sectionObject : null,
            widgetObject,
            paneObj,
            templateDetails
          )
        );
      } else if (!isWidgets && !isEditTemplate) {
        let basicObj = getTemplateListBasicObject(
          authParams,
          panes,
          index,
          pageSize,
          graphConditionConfig
        );
        authParams &&
          dispatch(
            setSaveTemplate(
              basicObj,
              templateData,
              sectionObject,
              widgetObject,
              paneObj
            )
          );
      } else {
        callNotification(
          "Please load all the sections before saving changes",
          "info"
        );
      }
    }
    dispatch(setAllSelectedCheckbox(false));
  };
  const dashbaordBenchmarkAggregation = useMemo(() => {
    return benchmarkAggregation && Array.isArray(benchmarkAggregation)
      ? benchmarkAggregation?.filter((agg) => agg?.value !== "custom")
      : [];
  }, [benchmarkAggregation]);
  return (
    <Modal
      title={<div className="text_heading fontSize-16">Dashboard Settings</div>}
      visible={isDashboardModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      style={{ top: 15 }}
      width={830}
      className={`dashboard_settings ${
        authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
      }`}
      footer={
        <div className="w-100 text-right">
          <Button onClick={handleCancel} className="btn_Clear mr-15">
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={handleSaveDashboard}
            loading={templateSectionFetchLoader ? true : false}
            className="ant-btn-primary_blue"
          >
            Save Dashboard
          </Button>
        </div>
      }
    >
      <Layout>
        {/* Login Access Type 2 is for ORM Users */}
        {workspace_privileges?.login_access_type !== 1 && (
          <Typography>
            <Paragraph>
              <Text className="text_heading font-weight500">
                Default Filters
              </Text>
              <Text className="text-gray d-block line-height-normal font-size13">
                With this filter, the data in all the widgets are filtered for
                the channel selected. The channel filters in the dashboard and
                its widgets will be disabled.
              </Text>
            </Paragraph>
          </Typography>
        )}

        {workspace_privileges?.login_access_type !== 1 && (
          <Typography>
            <Paragraph>
              <Text className="mb-2">
                <Checkbox
                  autoFocus={true}
                  checked={socialChannel}
                  onChange={onCheckBoxChange}
                >
                  <Text className="text_heading font-weight500">Channel</Text>
                </Checkbox>
              </Text>

              <Radio.Group
                onChange={onChannelChange}
                value={channelList}
                className="w-100"
                disabled={socialChannel ? false : true}
              >
                {graphConditionConfig?.[`hidden-filter-channels`]?.map((d) => {
                  if (
                    workspace_privileges?.login_access_type === 1 &&
                    d?.text?.toLowerCase() === "survey" &&
                    d?.value?.toLowerCase() === "survey"
                  ) {
                    return null;
                  } else {
                    return (
                      <>
                        <Radio
                          disabled={
                            dashboardType === "competition" &&
                            d?.value === "LinkedIn"
                          }
                          className="text_regular font-size13"
                          value={d?.value}
                        >
                          {d?.text}
                        </Radio>
                      </>
                    );
                  }
                })}
              </Radio.Group>
            </Paragraph>
          </Typography>
        )}

        {workspace_privileges?.login_access_type !== 1 && (
          <Typography>
            <Paragraph>
              <Text className="text_heading font-weight500">Quick Filters</Text>
              <Text className="d-block font-size13 text_regular-gray">
                Create a filter shortcut that appears on top of the dashboards
                for all the viewers.
              </Text>
              <Radio.Group onChange={onQuickFilterChange} value={quickFilter}>
                {graphConditionConfig?.[`quick_filter_mapping`]?.map((d) => {
                  if (
                    workspace_privileges?.login_access_type === 1 &&
                    d?.text?.toLowerCase() === "form" &&
                    d?.value?.toLowerCase() === "objectid"
                  ) {
                    return null;
                  } else {
                    return (
                      <>
                        <Radio
                          style={
                            dashboardType === "competition" ||
                            !graphConditionConfig?.[
                              `quick_filter_channel_mapping`
                            ]?.[d?.text]?.includes(
                              channelList ? channelList : "DEFAULT"
                            )
                              ? {
                                  opacity: "0.5",
                                  pointerEvents: "none",
                                }
                              : {
                                  opacity: "1",
                                  pointerEvents: "auto",
                                }
                          }
                          disabled={
                            dashboardType === "competition" ||
                            !graphConditionConfig?.[
                              `quick_filter_channel_mapping`
                            ]?.[d?.text]?.includes(
                              channelList ? channelList : "DEFAULT"
                            )
                              ? true
                              : false
                          }
                          className="text_regular font-size13"
                          value={d?.value}
                        >
                          {d?.text}
                        </Radio>
                      </>
                    );
                  }
                })}
                <Radio
                  style={{
                    opacity: dashboardType === "competition" ? "0.5" : "1",
                    pointerEvents:
                      dashboardType === "competition" ? "none" : "auto",
                  }}
                  disabled={dashboardType === "competition" ? true : false}
                  className="text_regular font-size13"
                  value={null}
                >
                  None
                </Radio>
              </Radio.Group>

              {/* <Radio.Group onChange={onQuickFilterChange} value={quickFilter}>
              <Radio
                style={{
                  opacity:
                    dashboardType === "competition" || channelList === "Survey"
                      ? "0.5"
                      : "1",
                  pointerEvents:
                    dashboardType === "competition" || channelList === "Survey"
                      ? "none"
                      : "auto",
                }}
                disabled={
                  dashboardType === "competition" || channelList === "Survey"
                    ? true
                    : false
                }
                className="text_regular font-size13"
                value={"CampaignID"}
              >
                Campaigns
              </Radio>
              <Radio
                style={{
                  opacity:
                    dashboardType === "competition" || channelList === "Survey"
                      ? "0.5"
                      : templateType === "competition" || !socialChannel
                      ? "0.5"
                      : "1",
                  pointerEvents:
                    dashboardType === "competition" || channelList === "Survey"
                      ? "none"
                      : templateType === "competition" || !socialChannel
                      ? "none"
                      : "auto",
                }}
                disabled={
                  dashboardType === "competition" || channelList === "Survey"
                    ? true
                    : socialChannel
                    ? false
                    : true
                }
                className="text_regular font-size13"
                value={"AccountID"}
              >
                Profiles
              </Radio>
              <Radio
                style={{
                  opacity:
                    dashboardType === "competition" || channelList === "Survey"
                      ? "0.5"
                      : "1",
                  pointerEvents:
                    dashboardType === "competition" || channelList === "Survey"
                      ? "none"
                      : "auto",
                }}
                disabled={
                  dashboardType === "competition" || channelList === "Survey"
                    ? true
                    : false
                }
                className="text_regular font-size13"
                value={"Category"}
              >
                Category
              </Radio>
              <Radio
                style={{
                  opacity:
                    dashboardType === "competition" || channelList === "Survey"
                      ? "0.5"
                      : channelList !== "GMB"
                      ? "0.5"
                      : "1",
                  pointerEvents:
                    dashboardType === "competition" || channelList === "Survey"
                      ? "none"
                      : channelList !== "GMB"
                      ? "none"
                      : "auto",
                }}
                disabled={
                  dashboardType === "competition" || channelList === "Survey"
                    ? true
                    : channelList === "GMB"
                    ? false
                    : true
                }
                className="text_regular font-size13"
                value={"LocationID"}
              >
                Location
              </Radio>
              <Radio
                style={{
                  opacity:
                    dashboardType === "competition"
                      ? "0.5"
                      : channelList !== "Survey"
                      ? "0.5"
                      : "1",
                  pointerEvents:
                    dashboardType === "competition"
                      ? "none"
                      : channelList !== "Survey"
                      ? "none"
                      : "auto",
                }}
                disabled={
                  dashboardType === "competition"
                    ? true
                    : channelList === "Survey"
                    ? false
                    : true
                }
                className="text_regular font-size13"
                value={"ObjectID"}
              >
                Form
              </Radio>
              <Radio
                style={{
                  opacity: dashboardType === "competition" ? "0.5" : "1",
                  pointerEvents:
                    dashboardType === "competition" ? "none" : "auto",
                }}
                disabled={dashboardType === "competition" ? true : false}
                className="text_regular font-size13"
                value={null}
              >
                None
              </Radio>
            </Radio.Group> */}
            </Paragraph>
          </Typography>
        )}

        <Typography>
          <Text className="text_heading font-weight500">Standard Filter</Text>
          <Text className="text_regular-gray d-block font-size13">
            Select brands and duration as standard filters when loading this
            dashboard.
          </Text>
          <div className="mt-15 mb-15">
            <div className="d-flex align-items-center mb-15">
              <div
                className="mr-15 floating-label-group header-brands"
                style={{ width: "30rem" }}
              >
                <BrandsLogicalGroup type="advance_settings" />
                <label
                  className="portlet-label floating-label mr-15"
                  style={{
                    backgroundColor: "#fff",
                    top: "-0.8rem",
                    fontSize: "1.2rem",
                  }}
                >
                  Brand
                </label>
              </div>
              <div className="d-flex align-items-center font-weight500">
                <Checkbox
                  checked={lock?.is_brand_locked}
                  onChange={onLockSelectedBrandChange}
                  className="mr-1"
                  disabled={
                    templateDetails?.advance_brands?.length === 0 ||
                    !templateDetails?.advance_brands ||
                    (templateDetails?.advance_brands &&
                      templateDetails?.advance_brands?.columns?.length === 0)
                      ? true
                      : false
                  }
                />
                <Text className="text_regular-gray mr-1 line-height-normal font-size13">
                  Lock Selected Brands
                </Text>
                <Tooltip
                  placement="right"
                  title="Brands selected here can not be changed while viewing the dashboard"
                >
                  <i className="fa fa-info-circle text-gray cursor-pointer" />
                </Tooltip>
              </div>
            </div>
            <div className="d-flex align-items-center mb-15">
              <div className="mr-15" style={{ width: "30rem" }}>
                <Datetime type="advance_settings" />
              </div>
              <div className="d-flex align-items-center font-weight500">
                <Checkbox
                  checked={lock?.is_date_locked}
                  onChange={onLockSelectedDurationChange}
                  className="mr-1"
                  disabled={
                    templateDetails?.advance_duration?.from &&
                    templateDetails?.advance_duration?.to
                      ? false
                      : true
                  }
                />
                <Text className="text_regular-gray font-size13 mr-1">
                  Lock Selected Duration{" "}
                </Text>

                <Tooltip
                  placement="right"
                  title="The duration selected here can not be changed while viewing the dashboard"
                >
                  <i className="fa fa-info-circle text-gray cursor-pointer" />
                </Tooltip>
              </div>
            </div>
          </div>
        </Typography>

        {workspace_privileges?.login_access_type !== 1 && (
          <Typography>
            <Text className="text_heading font-weight500">Dashboard Type</Text>
            <Text className="text_regular-gray font-size13 d-block line-height-normal mb-2">
              Choose the dashboard type between Normal and benchmark. Select
              benchmark for comparison dashboards, for an aggregation line to be
              added to all supported charts.
            </Text>
            <Radio.Group onChange={onDashboardTypeChange} value={dashboardType}>
              <Radio className="text_regular" value={"custom"}>
                Normal
              </Radio>
              <Radio
                disabled={!competitorBrands?.length ? true : false}
                className="text_regular"
                value={"competition"}
              >
                Competition Benchmarking
                {!competitorBrands?.length ? (
                  <Tooltip
                    placement="right"
                    title="Configure competition brand groups to enable"
                  >
                    <img className="ml-1" src={infoIcon} alt="information" />
                  </Tooltip>
                ) : (
                  <Tooltip
                    placement="right"
                    title="Utilize comparative benchmarking to measure brand performance versus key market players across standardized metrics."
                  >
                    <img className="ml-1" src={infoIcon} alt="information" />
                  </Tooltip>
                )}
              </Radio>
              <Radio className="text_regular" value={"benchmarking"}>
                Other Benchmarking
                <Tooltip
                  placement="right"
                  title="Identify performance trends and anomalies within brand dimensions(like Category, Location Profiles, Channels, etc.) using structured benchmarking"
                >
                  <img className="ml-1" src={infoIcon} alt="information" />
                </Tooltip>
              </Radio>
            </Radio.Group>
            {["competition", "benchmarking"]?.includes(templateType) && (
              <div className="mt-15 floating-label-group header-brands w-100">
                <Select
                  style={{ width: "22rem" }}
                  disabled={
                    ["competition", "benchmarking"]?.includes(dashboardType)
                      ? false
                      : true
                  }
                  onChange={(e) => onBenchMarkChange(e)}
                  value={aggrigation}
                  dropdownClassName={
                    authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
                  }
                >
                  {dashbaordBenchmarkAggregation &&
                  Array.isArray(dashbaordBenchmarkAggregation) ? (
                    <>
                      {dashbaordBenchmarkAggregation?.map((aggrigation, i) => {
                        return (
                          <Option
                            key={`banchmark_aggregation_${i}`}
                            value={aggrigation?.value}
                          >
                            {aggrigation?.label}
                          </Option>
                        );
                      })}
                    </>
                  ) : (
                    ""
                  )}
                  {/* <Option value="avg">Average</Option>
                  <Option value="min">Minimum</Option>
                  <Option value="max">Maximum</Option>
                  <Option value="median">Median</Option> */}
                </Select>
                <Tooltip
                  placement="right"
                  className="ml-2"
                  title="Choose between the type of aggregation for benchmark line"
                >
                  <i className="fa fa-info-circle text-gray cursor-pointer" />
                </Tooltip>
                <label
                  className="portlet-label floating-label mr-15"
                  style={{
                    backgroundColor: "#fff",
                    top: "-0.8rem",
                    fontSize: "1.2rem",
                  }}
                >
                  Aggregation
                </label>
              </div>
            )}
          </Typography>
        )}
      </Layout>
    </Modal>
  );
};

export default SaveDashboardModal;
